import CyberSecurity from '../apis/cyberSecurityData';

export const changeToBreach = (itemId) => async (dispatch, getState) => {

    try {
        const response = await CyberSecurity.post('/converttobreach', { itemId }, {
            headers: {
                Authorization: `Bearer ${getState().accessToken}`
            }
        })
        dispatch({ type: 'CHANGE_TO_BREACH', payload: response.data })

    } catch (error) {
        console.log({ error: error.message })
    }
}

export const updateItemData = (itemId, data) => async (dispatch, getState) => {

    try {
        const response = await CyberSecurity.post('/updatedata', { itemId, data }, {
            headers: {
                Authorization: `Bearer ${getState().accessToken}`
            }
        })
        dispatch({ type: 'UPDATE_ITEM_DATA', payload: response.data })

    } catch (error) {
        console.log({ error: error.message })
    }


}